import { render, staticRenderFns } from "./reserveSuppliers.vue?vue&type=template&id=1622a0a5&"
import script from "./reserveSuppliers.vue?vue&type=script&lang=js&"
export * from "./reserveSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./reserveSuppliers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports